// Typelizer digest 4aec4149b2295d57ad15f6215db66cfd
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** PATCH /c/:company_id/documents/:document_id/company */
  update: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/documents/:document_id/company', params, options),
    method: 'patch',
  }),
}
